import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import * as detallePedidoActions from '../../reducers/DetallePedidoReducer/actions'
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import ItemResumenPedido from "./itemResumenPedido";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import DeleteIcon from "@material-ui/icons/Delete";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Row, Col } from "react-flexbox-grid";
import { connect } from "react-redux";
import {
  instalacionSelector,
  usuarioSelector,
} from "../../selectors/sessionSelector";
import * as sessionActions from "../../reducers/SessionReducer/actions";
import * as pedidoActions from "../../reducers/PedidoReducer/actions";
import { pedidoDataSelector } from "../../selectors/pedidoSelector";
import { bindActionCreators } from "redux";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputBase from "@material-ui/core/InputBase";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import * as Notification from "../../components/Common/notification";
import { RESUMEN_PEDIDO_DRAWER_WIDTH } from "../../config/layoutConstants";
import "./styles.css";
import _axios from "../../apiClient";

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        "5",
        "4",
        " ",
        "9",
        " ",
        /[1-9]/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      //mask={['+54', ' ', '9', ' ', /[1-9]/, /[1-9]/, /[1-9]/, ' ', /[1-9]/, /[1-9]/, /[1-9]/,'-', /[1-9]/, /[1-9]/, /[1-9]/, /[1-9]/]}
      placeholderChar={"_"}
      showMask
      keepCharPositions={false}
      guide={true}
    />
  );
}

const drawerWidth = RESUMEN_PEDIDO_DRAWER_WIDTH;

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    opacity: 1,
  },
  drawerPaper: {
    width: drawerWidth,
    background: "#EFF0F8 0% 0% no-repeat padding-box",
    opacity: 1,
    zIndex: 1200,
    border: "none",
  },
  content: {
    flexGrow: 1,
    padding: "0px",
    marginTop: "30px",
  },
  rootContent: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "21px",
    opacity: 1,
    maxWidth: "850px",
    minWidth: "300px",
    padding: "0px !important",
  },
});

const VaciarCarritooTooltip = withStyles((theme) => ({
  tooltip: {
    background: "#000000 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "4px",
    padding: "0px",
    opacity: "1 !important",
    margin: "7px 0 4px 25px !important",
  },
}))(Tooltip);

const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

const DrawerResumenPedido = ({ classes, ...props }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalExito, setOpenModalExito] = React.useState(false);
  const [facturacion, setFacturacion] = React.useState(false);
  const [disablePagar, setDisablePagar] = React.useState(false);
  const [clearPedido, setClearPedido] = React.useState(false);
  const [errores, setErrores] = React.useState({});
  const [form, setForm] = React.useState({});
  const [pedidoDetalleConPromo, setPedidoDetalleConPromo] = React.useState([]);
  const [descuentoTotal, setDescuentoTotal] = React.useState(0);

  const toFixedCustomize = (num) => {
    var resultado = num.toFixed(6).slice(0, -4);
    return resultado;
  };
  const handleOnClickFinalizarCompra = () => {
    setDisablePagar(true);
    setClearPedido(false);
    let payload = {
      Id: props.dataPedido.pedido.id,
      IdEstadoPedido: 2,
      IdFormaPagoOnline: 1,
      IdFormaEntrega: 1,
      IdInstalacion: props.instalacion ? props.instalacion.id : 0,
      IdTipoFacturacion: facturacion.tipoFacturacion || 1,
      IdClienteDatosFacturacion: facturacion.idClienteDatosFacturacion,
    };

    payload.callback = () => {
      setOpenModalExito(true);
      setOpenModal(false);
      setDisablePagar(false);
    };
    props.sagaConfirmarEliminarPedido(payload);
  };

  React.useEffect(() => {
    if (clearPedido) {
      props.setPedidoBorrador(undefined);
      props.setShowResumenPedido(false);
    }
  
    const fetchDescuento = async () => {
      try {
        const res = await _axios.get(`/api/Pedido/GetPedidoBorradorPorUsuario?idUsuario=${props.usuario.id}`);
        setDescuentoTotal(res.data.descuento);
      } catch (error) {
        console.log("error", error);
      }
    }

    const fetchPromoPorCantidad = async () => {
      const updatedPedidoDetalle = await Promise.all(
        props.pedido.listaPedidoDetalle.map(async (element) => {
          try {
            const res = await _axios.get(`/api/Articulo/GetArticulo?idArticulo=${element.idArticulo}`);
            return { ...element, promoPorCantidad: res.data.promoPorCantidad, catalogoDiscount: res.data.descuentoCatalogo };
          } catch (err) {
            console.log("err", err);
            return element;
          }
        })
      );
      setPedidoDetalleConPromo(updatedPedidoDetalle);
    };
    fetchDescuento();
    fetchPromoPorCantidad();
  }, [clearPedido, props.pedido.listaPedidoDetalle]);

  const handleOnSaveDatosAdicionales = () => {
    let valida = true;
    let errores = {};
    // valido el documento
    if (
      form.documento === undefined ||
      form.documento === "" ||
      form.documento.length < 7
    ) {
      errores.documento = "Ingrese un Nro. de documento correcto";
      valida = false;
    }

    // valido el celular
    if (
      form.phoneNumber === undefined ||
      form.phoneNumber === "" ||
      form.phoneNumber.includes("_") ||
      form.phoneNumber.includes(".")
    ) {
      errores.phoneNumber = "Ingrese un celular correcto";
      valida = false;
    }

    // valido el teléfono
    if (
      form.telefono !== undefined &&
      (form.telefono === "" ||
        form.telefono.includes("_") ||
        form.telefono.includes("."))
    ) {
      errores.telefono = "Ingrese un teléfono correcto";
      valida = false;
    }

    if (!valida) {
      setErrores(errores);
      return;
    }
    setErrores({});

    let payload = {
      dni: form.documento.trim(),
      telefono: form.telefono ? form.telefono.trim() : "",
      phoneNumber: form.phoneNumber.trim(),
      idUsuario: props.usuario.id,
    };

    payload.callback = () => {
      Notification.showSuccess(`Datos guardados con éxito`);
      setOpenModal(false);
    };

    payload.callbackError = () => {
      Notification.showError(`Error al guardar los datos`);
    };

    props.sagaSaveDatosAdicionales(payload);
  };

  const handleOnDataChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "documento" && value !== "") {
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if (value.length > 9 || !value.match(letterNumber)) {
        return;
      }
    }
    let form1 = { ...form };

    form1[name] = value;

    setForm(form1);
  };

  React.useEffect(() => {
    const preferenciasPayload = {};
    preferenciasPayload.idCliente = props.usuario.idCliente;
    preferenciasPayload.callback = (preferencias) => {
      const { idTipoFacturacion, idClienteDatosFacturacion } = preferencias;
      setFacturacion({
        tipoFacturacion: idTipoFacturacion,
        idClienteDatosFacturacion,
      });
    };
    props.sagaGetPreferenciasUltimoPedido(preferenciasPayload);
  }, []);

  return (
    <>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        className={`${classes.drawer} ${
          props.isPersistent ? "drawerPersistent" : "drawerClasic"
        }`}
        variant={`${props.isPersistent ? "persistent" : "temporary"}`}
        anchor="right"
        open={props.open}
        classes={{
          paper: classes.drawerPaper,
        }}
        onClose={props.handleOnClose}
      >
        <div className="containerResumenPedido">
          {!props.isPersistent && (
            <IconButton
              color="default"
              aria-label="Back"
              className="arrowCloseResumen"
              onClick={props.handleOnClose}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {/* INFO USUARIO */}
          <div className="containerInfoUsuario">
            <div className="imgUsuario">
              <img src={require("../../images/usuarioM.png")} alt=""></img>
            </div>
            <div>
              <div className="labelNombre">
                Hola&nbsp;<span>{props.usuario.nombre}</span>
              </div>
              <div className="labelEmail">{props.usuario.nombreUsuario}</div>
            </div>
          </div>
          {/* MI CARRITO */}
          <div className="containerMiCarrito">
            <div className="tituloCarrito">Mi carrito</div>
            <VaciarCarritooTooltip
              TransitionComponent={Zoom}
              placement="bottom-end"
              style={{ opacity: "1" }}
              enterTouchDelay={10}
              title={
                <div className="containerTooltipVaciarCarrito">
                  Vaciar carrito
                </div>
              }
            >
              <div className="vaciarCarrito">
                <DeleteIcon onClick={props.handleOnVaciarCartito} />
              </div>
            </VaciarCarritooTooltip>
          </div>

          <div
            id="scrollItemsPedido"
            className={`itemPedidos ${
              props.pedido.precioLista !== props.pedido.precioFinal
                ? ""
                : "itemPedidosAux"
            }`}
          >
            {props.loading !== true &&
              pedidoDetalleConPromo.map((pd) => {
                return (
                  <ItemResumenPedido
                    key={pd.idPedidoDetalle}
                    pedidoDetalle={pd}
                    handleAgregarQuitarUnidad={props.handleAgregarQuitarUnidad}
                    logoCard={props.instalacion.logoCard}
                  />
                );
              })}

            {props.loading === true && (
              <div className="containerLoaderResumen">
                <CircularProgress />
              </div>
            )}
          </div>
          {/* SEPARADOR */}
          <div className="separador"></div>
          {/* BUTTON */}
          {props.instalacion.montoCompraMinimoPermitido === undefined ||
          props.instalacion.montoCompraMinimoPermitido === null ||
          props.instalacion.montoCompraMinimoPermitido === 0 ||
          (props.instalacion.montoCompraMinimoPermitido > 0 &&
            props.pedido.precioFinal >=
              props.instalacion.montoCompraMinimoPermitido) ? (
            <div className="containerBtnCheckout">
              <Button
                className="btnCheckout"
                onClick={() => setOpenModal(true)}
              > 
                Comprar
              </Button>
            </div>
          ) : (
            <div className="textMontoMínimo">
              Monto mínimo de compra $
              {props.instalacion.montoCompraMinimoPermitido.toFixed(2)}
            </div>
          )}
        </div>
      </SwipeableDrawer>
      {/*props.usuario.dni && props.usuario.phoneNumber*/ true ? (
        <Dialog
          classes={{ paperScrollPaper: classes.rootContent }}
          open={openModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent classes={{ root: classes.rootContent }}>
            <Row style={{ margin: "0px" }}>
              <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                <div className="compraExitosa">
                  <div className="labelTitle">COMPRAR</div>

                  <div className="containerInfoCompraExitosa">
                    <div className="labelDescripcion">
                      Estás por finalizar el proceso de compra.
                    </div>

                    <div className="labelDescripcion">
                      Gracias por elegir Siri
                    </div>
                  <div className="detallesPagoModal">
                    {(props.usuario.porcentajeDescuentoFullCatalogo ||
                      props.pedido.precioLista !== props.pedido.precioFinal) && (
                        <div className="subtotal">
                          <div>Subtotal</div>
                          <div style={{ fontWeight: "bold" }}>
                            ${toFixedCustomize(props.pedido.precioLista)}
                          </div>
                        </div>
                      )}
                    {(props.usuario.porcentajeDescuentoFullCatalogo ||
                      props.pedido.precioLista !== props.pedido.precioFinal) && (
                        <div className="descuentos">
                          <div>Descuentos</div>
                          <div style={{ fontWeight: "bold" }}>
                            $
                            {(props.pedido.precioLista - props.pedido.precioFinal).toFixed(2)}
                          </div>
                        </div>
                      )}
                    <div className="infoTotal">
                      <div style={{color: '#0c3653'}}>Total</div>
                      <div style={{ fontWeight: "bold" }}>
                        ${toFixedCustomize(props.pedido.precioFinal )}
                      </div>
                    </div>
                  </div>
                    <div className="buttonContainer">
                      <Button
                        className="buttonSecondary"
                        onClick={() => {
                          setOpenModal(false);
                          setDisablePagar(false);
                        }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        className="buttonPrimary"
                        disabled={disablePagar}
                        onClick={() => {
                          handleOnClickFinalizarCompra();
                        }}
                      >
                        Comprar
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          classes={{ paperScrollPaper: classes.rootContent }}
          open={openModal}
          //onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogContent classes={{ root: classes.rootContent }}>
            <Row style={{ margin: "0px" }}>
              <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                <div className="datosAdicionales">
                  <div className="labelTitle">Completa estos datos</div>

                  <div className="containerFormAdicionales">
                    <div className="inputContainer">
                      <span class="label">Número documento *</span>
                      <InputBase
                        placeholder="Nro. Documento"
                        value={form.documento}
                        name="documento"
                        onChange={handleOnDataChange}
                        error={errores.documento !== undefined}
                      />
                      {errores.documento !== undefined && (
                        <FormHelperText error style={{ marginTop: "3px" }}>
                          {errores.documento}
                        </FormHelperText>
                      )}
                    </div>

                    <div className="inputContainer">
                      <span class="label">Celular (sin 0 y sin 15) *</span>
                      <Input
                        placeholder="Celular"
                        value={form.phoneNumber}
                        onChange={handleOnDataChange}
                        name="phoneNumber"
                        inputComponent={TextMaskCustom}
                        error={errores.phoneNumber !== undefined}
                      />
                      {errores.phoneNumber !== undefined && (
                        <FormHelperText error>
                          {errores.phoneNumber}
                        </FormHelperText>
                      )}
                    </div>

                    <div className="inputContainer">
                      <span class="label">Teléfono</span>
                      <Input
                        placeholder="Teléfono"
                        value={form.telefono}
                        onChange={handleOnDataChange}
                        name="telefono"
                        inputComponent={TextMaskCustom}
                        error={errores.telefono !== undefined}
                      />
                      {errores.telefono !== undefined && (
                        <FormHelperText error>
                          {errores.telefono}
                        </FormHelperText>
                      )}
                    </div>

                    <div className="buttonContainer">
                      <Button onClick={() => handleOnSaveDatosAdicionales()}>
                        Guardar datos
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </DialogContent>
        </Dialog>
      )}
      {/* MODAL CONFIRMACION DE PEDIDO */}

      <Dialog
        classes={{ paperScrollPaper: classes.rootContent }}
        open={openModalExito}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent classes={{ root: classes.rootContent }}>
          <Row style={{ margin: "0px" }}>
            <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
              <div className="compraExitosa">
                <div className="labelTitle">COMPRA EXITOSA</div>

                <div className="containerInfoCompraExitosa">
                  <div className="labelDescripcion">
                    Hemos recibido tu pedido.
                  </div>
                  <div className="labelDescripcion">
                    A la brevedad nos pondremos en contacto contigo.
                  </div>
                  <div className="labelDescripcion">Muchas gracias.</div>

                  <div className="buttonContainer">
                    <Button
                      className="buttonPrimary"
                      onClick={() => {
                        setOpenModalExito(false);
                        setClearPedido(true);
                      }}
                    >
                      Entendido!
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>
    </>
  );
};

DrawerResumenPedido.defaultProps = {
  open: true,
};

DrawerResumenPedido.propTypes = {
  usuario: PropTypes.object.isRequired,
  pedido: PropTypes.object.isRequired,
  instalacion: PropTypes.object.isRequired,
  handleOnClickCheckout: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  isPersistent: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleOnClose: PropTypes.func,
  handleAgregarQuitarUnidad: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  handleOnVaciarCartito: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...pedidoActions,
      ...sessionActions,
      ...detallePedidoActions
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    usuario: usuarioSelector(state),
    instalacion: instalacionSelector(state),
    dataPedido: pedidoDataSelector(state),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DrawerResumenPedido));
